import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type Kind = 'customer' | 'vendor' | 'none';

interface Props {
  kind: Kind | undefined | null;
  className?: string;
}

/**
 * Small chip showing whether a sales document points at a customer (M-type
 * cari) or a vendor (B/S-type cari). Hidden for legacy "none" rows where
 * the counterparty was never linked.
 */
export function CounterpartyBadge({ kind, className }: Props) {
  const { t } = useTranslation('trading');
  if (!kind || kind === 'none') return null;
  return (
    <span
      className={cn(
        'inline-block px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide',
        kind === 'vendor'
          ? 'bg-purple-100 text-purple-700'
          : 'bg-blue-100 text-blue-700',
        className
      )}
    >
      {kind === 'vendor' ? t('cari.vendor') : t('cari.customer')}
    </span>
  );
}
